/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type FollowingRefetchWrapper_user$ref = any;
type Recommendations_trending$ref = any;
export type FollowingContainer_viewer$ref = any;
export type FollowingContainer_viewer = {
    readonly user?: {
        readonly " $fragmentRefs": FollowingRefetchWrapper_user$ref;
    } | null;
    readonly " $fragmentRefs": Recommendations_trending$ref;
    readonly " $refType": FollowingContainer_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "FollowingContainer_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "userId",
            "type": "String!"
        },
        {
            "kind": "RootArgument",
            "name": "hasUserId",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Recommendations_trending",
            "args": null
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "userId",
                            "variableName": "userId"
                        }
                    ],
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "FollowingRefetchWrapper_user",
                            "args": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'cc737ef1358a6979cd16475e2e7bcf86';
export default node;
